import * as React from 'react';
import MUICircularProgress, { CircularProgressProps } from '@mui/material/CircularProgress';
export interface ICircularProgressProps extends Pick<CircularProgressProps, 'style' | 'size' | 'color' | 'value' | 'variant'> {}

export const CircularProgress = (props: ICircularProgressProps) => <MUICircularProgress {...props} />;
